/**
 * Output Restricted Media Key Status.
 *
 * @group DRM
 *
 * @beta
 */
export const OUTPUT_RESTRICTED = 'output-restricted';
